export * from "./schools.component";
